import React, { Component } from 'react';
import PlayOptionComponent from './PlayOptionComponent';
import FancyCheckbox from '../elements/FancyCheckbox';

export default class GameTypeSection extends Component {
	render() {
		const { title, options, onSelect, onConfirm, matchSearchListManager, gameTypeIsPending, exitingAfterMatchPick, optionContent, allDisabled, player } = this.props;
		let { checkedOptions } = this.props;
		if(!checkedOptions) {
			checkedOptions = {};
		}
		if(!options.length) {
			return null;
		}

		if(!player || !player.isMe()) {
			return (
				<div className='game_type'>
					<h4 className='game_type_heading page-sub-heading'>{title}</h4>
					<div className='game_options'>
						{options.map((option) => (
							(optionContent && <div key={option.toString()}>{optionContent(option)}</div>) ||
							<PlayOptionComponent
								key={option.toString()}
								option={option}
								onClick={onConfirm}
								matchSearchListManager={matchSearchListManager}
								gameTypeIsPending={gameTypeIsPending}
								exitingAfterMatchPick={exitingAfterMatchPick}
							/>
						))}
					</div>
				</div>
			);
		}
		else {
			return (
				<div className='game_type'>
					<h4 className='game_type_heading page-sub-heading'>{title}</h4>
					<div className='game_options'>
						{options.map((option) => (
							<FancyCheckbox
								disabled={allDisabled && !checkedOptions[option.toString()]}
								onChange={onSelect}
								checked={!!checkedOptions[option.toString()]}
								value={option.toString()}
								key={option.toString()}
							>
								{option.getTitle()}
							</FancyCheckbox>
						))}
					</div>
				</div>
			);
		}
	}
}

